import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Bearer-token fallback. The httpOnly cookie is the primary auth
// transport, but third-party-cookie blockers (Safari, some VPNs) need
// this fallback. Stored in localStorage on /auth/session response.
const TOKEN_KEY = "facemax_session_token";

export function setSessionToken(t) {
    try {
        if (t) localStorage.setItem(TOKEN_KEY, t);
        else localStorage.removeItem(TOKEN_KEY);
    } catch (_) {
        /* ignore */
    }
}

export function getSessionToken() {
    try {
        return localStorage.getItem(TOKEN_KEY) || null;
    } catch (_) {
        return null;
    }
}

export const api = axios.create({
    baseURL: API,
    timeout: 240000,
    withCredentials: true,
});

api.interceptors.request.use((cfg) => {
    const t = getSessionToken();
    if (t && !cfg.headers.Authorization) {
        cfg.headers.Authorization = `Bearer ${t}`;
    }
    return cfg;
});

export function fileUrl(storagePath) {
    return `${API}/files/${storagePath}`;
}
